import React from 'react';
import { BwjPageContent } from '../../../../framework/components/bwj-page-content';
import { BwjLabelField } from '../../../../framework/components/bwj-label-field';
import { BwjGrid, Row, Col, BwjCard } from '../../../../framework/components/bwj-layout';
import { Spacing } from '../../../../framework/components/bwj-layout/styles';
import { ProjectOverviewService } from '../../services/project-overview';
import { useProjectOverviewParams } from '../../../app-routes';
import { formatString, toTitleText } from '../../../../framework/utils/string';
import { ProjectStatus } from '../../../../entities-generated/common/project-status';
import { toDate } from '../../../../framework/utils/date-time';

export const PageProjectOverviewGeneralInfo: React.FunctionComponent = () => {
  const { id: projectId } = useProjectOverviewParams();
  const project = ProjectOverviewService.getOverview(projectId)!;

  return (
    <BwjPageContent contentDescription={'primary content (no subcontent)'}>
      <BwjCard>
        <BwjGrid>
          <Row bottomSpacing={Spacing.Large}>
            <Col small={12} large={4}>
              <BwjLabelField
                label={'Catalog code'}
                value={project.catalogCode}
                noBorder={true}
              />
            </Col>
            <Col small={12} large={4}>
              <BwjLabelField
                label={'Project status'}
                value={toTitleText(ProjectStatus[project.status])}
                noBorder={true}
              />
            </Col>
            <Col small={12} large={4}>
              <BwjLabelField
                label={'Commute time (blocks; round trip)'}
                value={project.commuteTimeBlocks.toString()}
                noBorder={true}
              />
            </Col>
          </Row>
          <Row bottomSpacing={Spacing.Large}>
            <Col small={12} large={4}>
              <BwjLabelField
                label={'Assessment performed'}
                value={formatString('{d:d-dMMMyyyy}', {d: toDate(project.assessmentPerformed)}).formattedString}
                noBorder={true}
              />
            </Col>
            <Col small={12} large={4}>
              <BwjLabelField
                label={'Installation scheduled'}
                value={project.installationScheduled === 0 ? 'N/A' : formatString('{d:d-dMMMyyyy}', {d: toDate(project.installationScheduled)}).formattedString}
                noBorder={true}
              />
            </Col>
            <Col small={12} large={4}>
              <BwjLabelField
                label={'Installation completed'}
                value={project.installationPerformed === 0 ? 'N/A' : formatString('{d:d-dMMMyyyy}', {d: toDate(project.installationPerformed)}).formattedString}
                noBorder={true}
              />
            </Col>
          </Row>
          <Row bottomSpacing={Spacing.Large}>
            <Col small={12}>
              <BwjLabelField
                label={'Notes'}
                value={project.notes}
                noBorder={true}
                multiline={true}
              />
            </Col>
          </Row>
        </BwjGrid>
      </BwjCard>
    </BwjPageContent>
  );
};
